/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
import { React, useState } from 'react'
import { WORKSPACE_MODE } from '../workspace-panel.const'
import { useLanguageContext } from '../../../context/locale.context'
import { Box, CircularProgress, CircularProgressLabel } from '@chakra-ui/react'
import Inviteparticipants from '../invite-participant'
import SVGIcon from '../../../assets/svgIcons'

export const InfoHeader = props => {
	const {
		setHeader,
		setActivityTabs,
		setworkspaceMode,
		isActiveButton,
		activity,
		isOpen,
		activeTab,
	} = props

	const {
		activity_title,
		activity_status_name,
		activity_datetime_end_deferred,
		activity_workflow_completion_percentage: completion,
		activityParticipantId,
	} = activity

	const {
		state: { locale },
	} = useLanguageContext()
	return (
		<Box
			w='100%'
			h='70px'
			bg='white'
			p='10px 25px'
			display={'flex'}
			alignItems='center'
			justifyContent='space-between'
		>
			<Box
				minW='210px'
				minH='45px'
				display='flex'
				alignItems='center'
				justifyContent='flex-start'
			>
				<Box
					display='flex'
					alignItems='center'
					justifyContent='center'
					cursor='pointer'
					marginRight='15px'
					onClick={() => {
						setHeader(false)
						setActivityTabs(false)
						setworkspaceMode(WORKSPACE_MODE.TEAM_COLLABORATION)
					}}
				>
					<SVGIcon
						iconName='BackArrowGreenSvg'
						svgProps={{
							width: '12',
							height: '20',
							viewBox: '0 0 12 20',
						}}
						// pathProps={{ fill: '#009B76' }}
					/>
				</Box>
				<Box display='flex' flexDir='column' justifyContent='space-around'>
					<Box
						fontSize='18px'
						fontWeight='500'
						color='#009B76'
						textTransform='capitalize'
					>
						{activity_title}
					</Box>
					<Box fontSize='14px' fontWeight='500' color='#000000'>
						{locale['Status']}:{' '}
						{!!activity_status_name ? activity_status_name : ''}
					</Box>
				</Box>
			</Box>
			<Box
				display='flex'
				alignItems='center'
				justifyContent='space-around'
				gap='14px'
			>
				<Box w='32px' h='32px'>
					<CircularProgress
						value={completion || 0}
						color='#7ABE73'
						size='32px'
						thickness='7px'
					>
						<CircularProgressLabel>{completion || 0}%</CircularProgressLabel>
					</CircularProgress>
				</Box>
			</Box>
		</Box>
	)
}

export const ParticipantHeader = ({
	setHeader,
	setActivityTabs,
	setParticipantTabs,
	setworkspaceMode,
	activity,
	setIsActiveButton,
	isActiveButton,
	activeTab,
}) => {
	const {
		state: { locale },
	} = useLanguageContext()
	const [participantView, setParticipantview] = useState(false)
	const [isOpenactive, setIsOpenactive] = useState(false)
	return (
		<>
			<Box
				w='100%'
				h='70px'
				bg='white'
				p='10px 25px'
				display={'flex'}
				alignItems='center'
				justifyContent='space-between'
			>
				<Box
					minH='45px'
					display='flex'
					alignItems='center'
					justifyContent='flex-start'
				>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='center'
						cursor='pointer'
						marginRight='15px'
						onClick={() => {
							setIsActiveButton({
								...isActiveButton,
								[activeTab.current]: false,
								Info: true,
							})
							activeTab.current = 'Info'
							setParticipantTabs(false)
							setActivityTabs(true)
							setworkspaceMode(WORKSPACE_MODE.INFO)
						}}
					>
						{/* <Image src={backArrowIcon} alt='backArrow icon' /> */}
						<SVGIcon
							iconName='BackArrowGreenSvg'
							svgProps={{
								width: '12',
								height: '20',
								viewBox: '0 0 12 20',
							}}
							// pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box display='flex' flexDir='column' justifyContent='flex-start'>
						<Box fontSize='18px' fontWeight='500' color='#009B76'>
							{locale['Users'] || 'Users'}
						</Box>
					</Box>
				</Box>
				<Box
					display='flex'
					w='30px'
					h='30px'
					onClick={() => setIsOpenactive(true)}
					cursor='pointer'
				>
					<SVGIcon iconName='PlusSvg' />
				</Box>
			</Box>
			{isOpenactive && (
				<Inviteparticipants
					activity={activity}
					setParticipantview={setParticipantview}
					isOpenactive={isOpenactive}
					setIsOpenactive={setIsOpenactive}
				/>
			)}
		</>
	)
}
